import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../Breadcrumbs';
import LoadingSpinner from '../LoadingSpinner';
import PropTypes from 'prop-types';
import Youtube from 'react-youtube';
import './Video.css';

const Video = props => {
  const {
    match,
    videos,
    videoUrl,
    loading
  } = props;

  let video;

  if(videos) {
    video = videos.find(currentVideo => currentVideo.fields.url === match.url);
  }

  const breadcrumbs = [
    {
      label: 'videos',
      linkTo: '/videos'
    },
    {
      label: video ? video.fields.title : null
    }
  ];

  let videoStringArray;

  if (video || videoUrl) {
    let link = video ? video.fields.link : videoUrl;
    videoStringArray = link.split('/');
  }

  const validVideoId = videoStringArray
    ? videoStringArray[videoStringArray.length - 1].trim()
    : null;

  if (loading) {
      return <LoadingSpinner size="large" colorScheme="blue" />;
  }

  return (
    <section className="videos-overview-container container">
        {video ? (
          <Fragment>
            <header className="page-header">
              <Breadcrumbs crumbs={breadcrumbs} />
            </header>

            <div className="edu-video">
                <div className="edu-video__contents">
                    <Youtube videoId={validVideoId} />
                    {video.found_in && (
                      <div className="edu-learn">
                        <h4>Learn more:</h4>
                          <ul>
                            {video.found_in.map((page, index) => (
                              <li key={index}>
                                <Link to={page.link}>{page.title}</Link>
                              </li>
                            ))}
                          </ul>
                      </div>
                    )}
                </div>
            </div>
            </Fragment>
        ) : (
          <Youtube videoId={validVideoId} />
        )}
    </section>

  )
};

Video.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string
  }),
  videos: PropTypes.array,
  videoUrl: PropTypes.string,
  loading: PropTypes.bool
};

Video.defaultProps = {
  videos: null,
  match: null,
  videosUrl: null,
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/edu/Video.js